document.querySelectorAll( '.js-tabs' ).forEach( ( block, blockIndex ) => {

	const buttonsContainer = block.querySelector( '.js-tabs-buttons' );
	const panels = block.querySelectorAll( '.js-tabs-panel' );

	if ( !buttonsContainer || !panels.length ) {

		return;

	}

	buttonsContainer.innerHTML = '';
	buttonsContainer.setAttribute( 'aria-orientation', 'horizontal' );

	const blockId = block.id || `tabs-${blockIndex + 1}`;

	panels.forEach( ( panel, index ) => {

		const title = panel.getAttribute( 'data-tab-title' ) || `Tab ${index + 1}`;
		const button = document.createElement( 'button' );
		const tabId = `${blockId}-tab-${index + 1}`;
		const panelId = `${blockId}-panel-${index + 1}`;

		button.type = 'button';
		button.className = 'b-tabs__button js-tabs-button';
		button.id = tabId;
		button.setAttribute( 'role', 'tab' );
		button.setAttribute( 'aria-selected', 'false' );
		button.setAttribute( 'aria-controls', panelId );
		button.setAttribute( 'tabindex', '-1' );
		button.setAttribute( 'data-tab-index', `${index}` );
		button.textContent = title;

		panel.id = panelId;
		panel.setAttribute( 'role', 'tabpanel' );
		panel.setAttribute( 'aria-labelledby', tabId );

		buttonsContainer.appendChild( button );

	} );

	const buttons = block.querySelectorAll( '.js-tabs-button' );

	if ( !buttons.length ) {

		return;

	}

	/**
	 * Toggle active tab and panel by index.
	 *
	 * @param {number} index Active tab index.
	 */
	const activateTab = ( index ) => {

		buttons.forEach( ( button, buttonIndex ) => {

			const isActive = buttonIndex === index;

			button.classList.toggle( 'is-active', isActive );
			button.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
			button.setAttribute( 'tabindex', isActive ? '0' : '-1' );

		} );

		panels.forEach( ( panel, panelIndex ) => {

			const isActive = panelIndex === index;

			panel.classList.toggle( 'is-active', isActive );
			panel.hidden = !isActive;

		} );

	};

	buttons.forEach( ( button, index ) => {

		button.addEventListener( 'click', () => {

			activateTab( index );
			button.focus();

		} );

		button.addEventListener( 'keydown', ( event ) => {

			let nextIndex = null;

			switch ( event.key ) {

			case 'ArrowRight':
			case 'ArrowDown':
				nextIndex = ( index + 1 ) % buttons.length;
				break;
			case 'ArrowLeft':
			case 'ArrowUp':
				nextIndex = ( index - 1 + buttons.length ) % buttons.length;
				break;
			case 'Home':
				nextIndex = 0;
				break;
			case 'End':
				nextIndex = buttons.length - 1;
				break;
			default:
				return;

			}

			event.preventDefault();
			activateTab( nextIndex );
			buttons[nextIndex].focus();

		} );

	} );

	block.classList.add( 'is-ready' );
	activateTab( 0 );

} );
